 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		54: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		54: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app." + ({"7":"DeprecatedStyles","15":"EnhancedStyles","16":"app-components-Workflow-WorkflowContainer","17":"app-components-bibs-BibPage-BibPageContainer","18":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","19":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","20":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","21":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","22":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","23":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","24":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","25":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","26":"app-components-bibs-subpages-CommentPage-CommentPageContainer","27":"app-components-bibs-subpages-MarcPage-MarcPageContainer","28":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","29":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","30":"app-components-bibs-subpages-VideoPage-VideoPageContainer","31":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","32":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","33":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","34":"app-components-borrowing-fines-Fines-FinesContainer","35":"app-components-borrowing-fines-GlobalPaymentsPage","36":"app-components-borrowing-holds-Holds-HoldsContainer","37":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","38":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","39":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","40":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","41":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","42":"app-components-events-EventsSearchPage-EventsSearchPageContainer","43":"app-components-events-MyEventsPage-MyEventsPageContainer","44":"app-components-info-apps-UnregisterPage","45":"app-components-list-ListPageContainer","46":"app-components-locations-LocationsPage-LocationsPage","47":"app-components-search-Search-SearchContainer","48":"app-components-search-SearchPrintList-SearchPrintListContainer","49":"app-components-settings-account-UnregisterPage","50":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","51":"app-components-shelves-Shelf-ShelfContainer","52":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","53":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"859a909de973c9ba42d4","1":"9c862f7f59e24a1af9c2","2":"b10b6ad087f91478fdc0","3":"b3fb893e6da99f7e91f7","4":"abb1acfeda77f21e09fc","5":"bb406eca6e41509017bc","6":"2630e822654f2fb54b13","7":"435f0d3c14afee3b96e1","8":"01dc0324bfcfbd23d439","9":"b656812d2517588a501e","10":"434a1603465943b9f0ca","11":"146db0a4670ebbdc7a22","12":"19b28d3b287b18d8cf2e","13":"e030be8e6ae0c6e21cf4","14":"e8a98d7d7b91fb53f64d","15":"ae051d93f6f43cdeff9b","16":"10e15ecc917087965be1","17":"a5b9779867292fa8e8d4","18":"21fa7760c4e03dbfbf96","19":"f7d9a11e549b782f1597","20":"6d26fe5343a4c3100baa","21":"14aafb98c149618c6902","22":"5dd0ca62b24d00fcf0b7","23":"bb60cfd078859de6d1c5","24":"ac444f808c6a0441fb8a","25":"6bb85ec0dde259700f17","26":"ed45b577d9ace8f32f18","27":"90caaed5461b7148654b","28":"970e9c5229212740a0e0","29":"c202952006c83b7da6c6","30":"2efad9382b3815480458","31":"e30be5fce1b685e38d89","32":"a7528f3fbfc0853222be","33":"d83d05c94d2a3972fb1a","34":"361b0905b4d910576bba","35":"51a19ab0fdd1c0928215","36":"113aa5ba9dd14d82695b","37":"a81dbdba85ffb1bb3b87","38":"f42dd66585807d03a5b5","39":"1f2a6bc0b335ebc93f53","40":"9b7744972b74f80ea8bb","41":"d6d554ac84a9e5fb317f","42":"23d3377cfecde29f997a","43":"02b7571b3b6c87fae36a","44":"e31ee4d27933eefeccfd","45":"bf6c2d4f727996472917","46":"3b855117ad51f54c6d69","47":"2ecac0fac9cf9a584025","48":"65c4ebdfe1090687c5a3","49":"c598e918c1c31c2d1313","50":"120f058b3e24fa03c335","51":"9f079394d2d54388e7a7","52":"524cc6f6c4221c452407","53":"73473b899b10cf7ae1bc","55":"acfdf3c16de92735c4af","56":"18dcd03437d701fca447","57":"ac1e328560fc0d5c60c1","58":"ddd311ac012cc2594420"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"45":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"55":1,"56":1,"57":1,"58":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app." + ({"7":"DeprecatedStyles","15":"EnhancedStyles","16":"app-components-Workflow-WorkflowContainer","17":"app-components-bibs-BibPage-BibPageContainer","18":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","19":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","20":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","21":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","22":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","23":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","24":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","25":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","26":"app-components-bibs-subpages-CommentPage-CommentPageContainer","27":"app-components-bibs-subpages-MarcPage-MarcPageContainer","28":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","29":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","30":"app-components-bibs-subpages-VideoPage-VideoPageContainer","31":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","32":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","33":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","34":"app-components-borrowing-fines-Fines-FinesContainer","35":"app-components-borrowing-fines-GlobalPaymentsPage","36":"app-components-borrowing-holds-Holds-HoldsContainer","37":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","38":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","39":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","40":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","41":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","42":"app-components-events-EventsSearchPage-EventsSearchPageContainer","43":"app-components-events-MyEventsPage-MyEventsPageContainer","44":"app-components-info-apps-UnregisterPage","45":"app-components-list-ListPageContainer","46":"app-components-locations-LocationsPage-LocationsPage","47":"app-components-search-Search-SearchContainer","48":"app-components-search-SearchPrintList-SearchPrintListContainer","49":"app-components-settings-account-UnregisterPage","50":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","51":"app-components-shelves-Shelf-ShelfContainer","52":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","53":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"859a909de973c9ba42d4","1":"9c862f7f59e24a1af9c2","2":"b10b6ad087f91478fdc0","3":"b3fb893e6da99f7e91f7","4":"abb1acfeda77f21e09fc","5":"bb406eca6e41509017bc","6":"2630e822654f2fb54b13","7":"435f0d3c14afee3b96e1","8":"01dc0324bfcfbd23d439","9":"b656812d2517588a501e","10":"434a1603465943b9f0ca","11":"146db0a4670ebbdc7a22","12":"19b28d3b287b18d8cf2e","13":"e030be8e6ae0c6e21cf4","14":"e8a98d7d7b91fb53f64d","15":"ae051d93f6f43cdeff9b","16":"10e15ecc917087965be1","17":"a5b9779867292fa8e8d4","18":"21fa7760c4e03dbfbf96","19":"f7d9a11e549b782f1597","20":"6d26fe5343a4c3100baa","21":"14aafb98c149618c6902","22":"5dd0ca62b24d00fcf0b7","23":"bb60cfd078859de6d1c5","24":"ac444f808c6a0441fb8a","25":"6bb85ec0dde259700f17","26":"ed45b577d9ace8f32f18","27":"90caaed5461b7148654b","28":"970e9c5229212740a0e0","29":"c202952006c83b7da6c6","30":"2efad9382b3815480458","31":"e30be5fce1b685e38d89","32":"a7528f3fbfc0853222be","33":"d83d05c94d2a3972fb1a","34":"361b0905b4d910576bba","35":"51a19ab0fdd1c0928215","36":"113aa5ba9dd14d82695b","37":"a81dbdba85ffb1bb3b87","38":"f42dd66585807d03a5b5","39":"1f2a6bc0b335ebc93f53","40":"9b7744972b74f80ea8bb","41":"d6d554ac84a9e5fb317f","42":"23d3377cfecde29f997a","43":"02b7571b3b6c87fae36a","44":"e31ee4d27933eefeccfd","45":"bf6c2d4f727996472917","46":"3b855117ad51f54c6d69","47":"2ecac0fac9cf9a584025","48":"65c4ebdfe1090687c5a3","49":"c598e918c1c31c2d1313","50":"120f058b3e24fa03c335","51":"9f079394d2d54388e7a7","52":"524cc6f6c4221c452407","53":"73473b899b10cf7ae1bc","55":"acfdf3c16de92735c4af","56":"18dcd03437d701fca447","57":"ac1e328560fc0d5c60c1","58":"ddd311ac012cc2594420"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-nerf.bibliocommons.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2347);
